import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [];

export const dictionary = {
		"/": [12],
		"/(app)/earn": [13,[2,3]],
		"/(app)/farm": [14,[2,4]],
		"/(app)/gbera": [15,[2,5]],
		"/(app)/leaderboard": [16,[2,6]],
		"/(app)/positions": [17,[2,7]],
		"/(app)/privacy-policy": [18,[2,8]],
		"/(app)/swappee": [19,[2,9]],
		"/(app)/swappee/automation": [20,[2,9]],
		"/(app)/swappee/claim": [21,[2,9]],
		"/(app)/terms": [22,[2,10]],
		"/(app)/trade": [23,[2,11]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';